import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Utils
import { stopPropagation } from 'utils/event-handlers';


export default function TextWithNewlinesLinks({ text, elementType }) {
  const ElementType = elementType || 'div';

  return (
    <ElementType>
      {_.map(_.split(text, '\n'), (line, lineIndex) =>
        <span key={`line-${lineIndex}`}>
          {_.map(_.split(line, ' '), (word, wordIndex) => {
            if (!_.startsWith(word, 'http')) return (<span key={`task-notes-word-${wordIndex}`}>{word} </span>);

            return (
              <span key={`word-${wordIndex}`}>
                <a onClick={stopPropagation()} href={word} target="_blank">
                  {_.truncate(word, { length: 30 })}
                </a>
              </span>
            );
          })}
          <br />
        </span>
      )}
    </ElementType>
  );
}

TextWithNewlinesLinks.propTypes = {
  text: PropTypes.string.isRequired,
  elementType: PropTypes.string
};
